import React, { useContext, useEffect, useState } from "react";
import Question from "./Question";
import Stopwatch from "./Stopwatch";
import QuestionsData2 from "../constants/Data2";
import header from "../assets/images/header.jpeg";
import footer1 from "../assets/images/footer1.jpeg";
import footer2 from "../assets/images/footer2.jpeg";
import { StoreContext } from "../context/contextStore";
import Modal from "react-modal";

const Quiz2 = () => {
  const postData = async (user_id, full_name, phone_number, no_of_correct_ans, time_taken, groupName) => {
    const data = {
      user_id: user_id,
      quiz_id: 2,
      full_name: full_name,
      phone_number: phone_number,
      group_name: groupName,
      total_questions: 6,
      no_of_correct_ans: no_of_correct_ans,
      time_taken: formatTime(time_taken)
    };

    try {
      const response = await fetch('https://globaltechnologia.org/qrcodeNew/public/index.php/api/savedata', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        alert('Result Added Successfully');
      } else {
        alert('Failed to upload result, please fill the form and try again');
      }
    } catch (error) {
      alert('Failed to upload result, please fill the form and try again');
      console.error('POST request error:', error);
    }
  };
  useEffect(() => {
    const handleBackButtonPress = (event) => {
      event.preventDefault();
      window.location.href = "/";
    };

    window.addEventListener("popstate", handleBackButtonPress);

    return () => {
      window.removeEventListener("popstate", handleBackButtonPress);
    };
  }, []);

  const [questionsData2, setQuestionsData2] = useState(QuestionsData2);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [elapsedTimeFinal, setElapsedTimeFinal] = useState(0);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isGroupNameValid, setIsGroupNameValid] = useState(true);
  const [groupName, setGroupName] = useState("");
  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() { }

  function closeModal() {
    setIsOpen(false);
  }

  const [fullName, setFullName] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isFullNameValid, setIsFullNameValid] = useState(true);
  const [isIdNumberValid, setIsIdNumberValid] = useState(true);
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

  const [isNextPage, setIsNextPage] = useState(false);

  const [finalResult, setFinalResult] = useState(0);

  function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(remainingSeconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  const [firstTime, setFirstTime] = useState(true);
  useEffect(() => {
    setElapsedTime(Number(localStorage.getItem("timer1")));
  }, []);

  useEffect(() => {
    const storedValue2 = localStorage.getItem("value2");
    setFinalResult(Number(storedValue2));
  }, [localStorage.getItem("value2")]);

  const { correctAnswers2, correctAnswers, setCorrectAnswers2 } = useContext(
    StoreContext
  );

  const updateAnswer = (text, index) => {
    const updatedQuestionsData2 = [...questionsData2];
    updatedQuestionsData2[index].answer = text;
    setQuestionsData2(updatedQuestionsData2);
  };

  const checkForSubmit = () => {
    const newData = questionsData2.map((item, index) => {
      if (item.answer === item.solution) {
        return {
          ...item,
          isCorrect: true,
        };
      } else if (item.answer !== item.solution) {
        return {
          ...item,
          isCorrect: false,
        };
      }
      return {
        ...item,
      };
    });

    setQuestionsData2(newData);
    const correctItems = newData.filter((item) => item?.isCorrect === true);
    setCorrectAnswers2(correctItems.length);
    const final = correctItems.length;

    localStorage.setItem("value2", final.toString());
    setElapsedTimeFinal(elapsedTime);

    const isAnyQuestionUnanswered = questionsData2.some(
      (question) => question.answer === ""
    );

    if (
      isFullNameValid &&
      isIdNumberValid &&
      isPhoneNumberValid &&
      isGroupNameValid &&
      !isAnyQuestionUnanswered
    ) {
      openModal();
    }

    if (isAnyQuestionUnanswered) {
      alert("Please answer all the questions before submitting.");
    } else {
      // console.log(questionsData2);
      openModal();
      postData(idNumber, fullName, phoneNumber, finalResult, elapsedTime, groupName)

    }
  };
  const handleGroupNameChange = (event) => {
    const { value } = event.target;

    setGroupName(value);
    if (value == "") {
      setIsGroupNameValid(false);
    } else {
      setIsGroupNameValid(true);
    }
  };
  const handleFullNameChange = (event) => {
    const { value } = event.target;
    setFullName(value);
    setIsFullNameValid(value !== "");
  };

  const handleIdNumberChange = (event) => {
    const { value } = event.target;
    setIdNumber(value);
    setIsIdNumberValid(value !== "");
  };

  const handlePhoneNumberChange = (event) => {
    const { value } = event.target;
    setPhoneNumber(value);
    setIsPhoneNumberValid(value !== "");
  };

  return (
    <>
      <header className="header">
        <div className="header__logo">
          <img src={header} alt="logo" />
        </div>
      </header>

      {!isNextPage ? (
        <div className="wrapper">
          <div className="navbar">
            <h1 className="isra"></h1>
            <h1 className="sw">
              סטופר
              <div
                style={{
                  marginLeft: 10,
                }}
              >
                <Stopwatch
                  elapsedTime={elapsedTime}
                  setElapsedTime={setElapsedTime}
                />
              </div>
            </h1>
          </div>
          <div className="page">
            <div className="quizpage">
              <div className="nameID">
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    marginTop: "20px",
                  }}
                >
                  <input
                    type="text"
                    value={groupName}
                    onChange={handleGroupNameChange}
                    required
                  />
                  <div className="nameLabel">
                    <div className="nameLabelDiv" style={{ width: "169px" }}>
                      <label htmlFor="">שם קבוצה</label>
                    </div>
                  </div>
                </div>
                {!isGroupNameValid && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginRight: "50px",
                    }}
                    className="error-message"
                  >
                    שם מלא הוא שדה חובה
                  </div>
                )}
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    marginTop: "20px",
                  }}
                >
                  <input
                    type="text"
                    value={fullName}
                    onChange={handleFullNameChange}
                    required
                  />
                  <div className="nameLabel">
                    <div className="nameLabelDiv" style={{ width: "169px" }}>
                      <label htmlFor=""> שם מלא</label>
                    </div>
                  </div>
                </div>
                {!isFullNameValid && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginRight: "50px",
                    }}
                    className="error-message"
                  >
                    שם מלא הוא שדה חובה
                  </div>
                )}
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    marginTop: "20px",
                  }}
                >
                  <input
                    type="text"
                    value={idNumber}
                    onChange={handleIdNumberChange}
                    required
                  />
                  <div className="nameLabel">
                    <div className="nameLabelDiv" style={{ width: "169px" }}>
                      <label htmlFor="">תעודת זהות</label>
                    </div>
                  </div>
                </div>
                {!isIdNumberValid && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginRight: "50px",
                    }}
                    className="error-message"
                  >
                    תעודת זהות היא שדה חובה
                  </div>
                )}
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    marginTop: "20px",
                  }}
                >
                  <input
                    type="text"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    required
                  />
                  <div className="nameLabel">
                    <div className="nameLabelDiv" style={{ width: "169px" }}>
                      <label htmlFor="">מספר טלפון</label>
                    </div>
                  </div>
                </div>
                {!isPhoneNumberValid && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginRight: "50px",
                    }}
                    className="error-message"
                  >
                    מספר טלפון הוא שדה חובה
                  </div>
                )}
              </div>
              <h1>שאלות</h1>
              {questionsData2.map((item, index) => (
                <Question
                  setElapsedTime={setElapsedTime}
                  setData={updateAnswer}
                  myArray={questionsData2}
                  setMyArray={setQuestionsData2}
                  data={questionsData2}
                  index={index}
                  item={item}
                />
              ))}
            </div>
          </div>
          <div className="page">
            <button
              disabled={
                !isFullNameValid || !isIdNumberValid || !isPhoneNumberValid
              }
              className="send"
              onClick={checkForSubmit}
              title="Send"
            >
              שלח
            </button>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={() => {
              closeModal();
              window.location.href = "/page2";
            }}
          >
            <div
              style={{
                alignItems: "center",
                display: "flex",
                alignSelf: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <h2>זמן השלמה</h2>
                <h3>{formatTime(elapsedTimeFinal)}</h3>
                <h2>ציון</h2>
                <h3>{finalResult}</h3>
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        <div className="wrapper">
          <div className="navbar">
            <h1 className="isra">ישראלי ישראלי</h1>
            <h1 className="sw">
              סטופר
              <div
                style={{
                  marginLeft: 10,
                }}
              >
                <Stopwatch
                  elapsedTime={elapsedTime}
                  setElapsedTime={setElapsedTime}
                />
              </div>
            </h1>
          </div>
          <div className="page">
            <div className="quizpage">
              <div className="nameID">
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    marginTop: "20px",
                  }}
                >
                  <input
                    type="text"
                    value={fullName}
                    onChange={handleFullNameChange}
                    required
                  />
                  <div className="nameLabel">
                    <div style={{ width: "169px" }}>
                      <label htmlFor="">שם מלא</label>
                    </div>
                  </div>
                </div>
                {!isFullNameValid && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginRight: "50px",
                    }}
                    className="error-message"
                  >
                    שם מלא הוא שדה חובה
                  </div>
                )}
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    marginTop: "20px",
                  }}
                >
                  <input
                    type="text"
                    value={idNumber}
                    onChange={handleIdNumberChange}
                    required
                  />
                  <div className="nameLabel">
                    <div style={{ width: "169px" }}>
                      <label htmlFor="">תעודת זהות</label>
                    </div>
                  </div>
                </div>
                {!isIdNumberValid && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginRight: "50px",
                    }}
                    className="error-message"
                  >
                    תעודת זהות היא שדה חובה
                  </div>
                )}
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    marginTop: "20px",
                  }}
                >
                  <input
                    type="text"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    required
                  />
                  <div className="nameLabel">
                    <div style={{ width: "169px" }}>
                      <label htmlFor="">מספר טלפון</label>
                    </div>
                  </div>
                </div>
                {!isPhoneNumberValid && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginRight: "50px",
                    }}
                    className="error-message"
                  >
                    מספר טלפון הוא שדה חובה
                  </div>
                )}
              </div>
              <h1>שאלות</h1>
              {questionsData2.map((item, index) => (
                <Question
                  setElapsedTime={setElapsedTime}
                  setData={updateAnswer}
                  myArray={questionsData2}
                  setMyArray={setQuestionsData2}
                  index={index}
                  item={item}
                />
              ))}
            </div>
          </div>
          <div className="page">
            <button
              disabled={
                !isFullNameValid || !isIdNumberValid || !isPhoneNumberValid
              }
              className="send"
              onClick={checkForSubmit}
              title="Send"
            >
              שלח
            </button>
          </div>
        </div>
      )}

      <footer className="footer">
        <div className="footer__logo">
          <img src={footer1} alt="footer1" />
        </div>
        <div className="footer__logo">
          <img src={footer2} alt="footer2" />
        </div>
      </footer>
    </>
  );
};

export default Quiz2;
